"use client"
import { useState, useEffect } from "react"
import SwiperBanner from "components/SwiperBanner"
import { Layout } from "components/common"
import TypeEvent from "utils/TypeEvent"
import SwiperLive from "components/SwiperLive"
import SwiperVod from "components/SwiperVod"
import SwiperLiveShow from "components/SwiperLiveShow"
import SwiperChannel from "components/SwiperChannel"
import SwiperCategory from "components/SwiperCategory"
import SwiperStory from "components/SwiperStory"
import SwiperLeague from "components/SwiperLeague"
import Slide from "components/Slide3"
import { getPropsHomePage } from "lib/dataStore"
import { trackGA } from "lib/func"
import config from "lib/config"
import SwiperShort from "components/SwiperShort"

function renderBlock(type_block, item, leagues) {
  switch (type_block) {
    case TypeEvent.BANNER:
      return <SwiperBanner {...item} />
    case TypeEvent.LIVE:
      return <SwiperLive {...item} />
    case TypeEvent.LIVESHOW:
      return <SwiperLiveShow {...item} />
    case TypeEvent.CATEGORY:
      return <SwiperCategory {...item} />
    case TypeEvent.STORY:
      return <SwiperStory {...item} />
    case TypeEvent.LEAGUE:
      return <SwiperLeague leagues={leagues} {...item} />
    case TypeEvent.CHANNEL:
      return <SwiperChannel {...item} />
    case TypeEvent.VOD:
      return <SwiperVod {...item} />
    case TypeEvent.SHORT:
      return <SwiperShort {...item} />
    default:
      return <></>
  }
}

function Component({ screenblocks, slides, leagues }) {
  const [_screenblocks, setScreenblocks] = useState(screenblocks)
  const [_slides, setSlides] = useState(slides)
  const [_leagues, setLeagues] = useState(leagues)
  const [lastFetchTime, setLastFetchTime] = useState(Date.now())

  const fetchData = async () => {
    try {
      const timestamp = Date.now()
      const { screenblocks, slides, leagues } = await getPropsHomePage()
      console.log("HomeGetData: ", { screenblocks, slides, leagues })
      setScreenblocks(screenblocks)
      setSlides(slides)
      setLeagues(leagues)
      setLastFetchTime(timestamp)
    } catch (error) {
      console.error("HomeGetData: " + error.message)
    }
  }

  useEffect(() => {
    if (_screenblocks.length === 0) {
      fetchData().then()
    }
    trackGA("Trang chủ", "HOME_TAB")
  }, [])

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchData().then()
    }, config.TIME_REQUEST_HOME_PAGE)

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        const currentTime = Date.now()
        const lastFetchTime = sessionStorage.getItem("lastFetchTime") || 0
        const timeElapsed = currentTime - lastFetchTime
        if (timeElapsed >= config.TIME_REQUEST_HOME_PAGE) {
          fetchData().then()
        }
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      clearInterval(intervalId)
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [lastFetchTime])

  useEffect(() => {
    // Register service worker for Firebase Messaging
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/firebase-messaging-sw.js")
          .then(function (registration) {
            console.log("Service Worker registered with scope:", registration.scope)
          })
          .catch(function (err) {
            console.error("Service Worker registration failed:", err)
          })
      })
    }
  }, [])
  return (
    <section className="mb-12">
      <Slide slides={_slides} />
      <div className="pt-0 mx-auto mt-0 md:mt-10 space-y-10 overflow-x-hidden max-w-screen-xl px-4 md:px-6 lg:px-4">
        {_screenblocks?.length > 0 &&
          _screenblocks?.map((item) => {
            const { id, type_block } = item
            return <div key={id}>{renderBlock(type_block, item, _leagues)}</div>
          })}
      </div>
    </section>
  )
}

export default Component
Component.Layout = Layout

export async function getServerSideProps() {
  let pageProps = {
    screenblocks: [],
    slides: [],
    leagues: []
  }
  try {
    pageProps = await getPropsHomePage()
    console.log("getServerSideProps: " + JSON.stringify(pageProps))
  } catch (error) {
    console.error("getServerSideProps: " + error.message)
  }
  return { props: pageProps }
}
